import React, { useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import SuccessCheck from '../../../components/icons/SuccessCheck';
import { useTranslation } from 'react-i18next';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';
import Button from '../../../components/Common/Button/Button';
import { getReservation } from '../../../services/reservations/reservationsService';
import { getQueryString } from '../../../helpers/url';
import { WelletContext } from '../../../context/WelletContext';
import Money from '../../../components/Common/Money/Money';
import { CircleSpinner } from 'react-spinners-kit';
import CopyIcon from '../../../components/icons/copyIcon';
import { Toast } from '../../../components/Common/Toast/Toast';
import Qr from '../../../components/Common/Qr/Qr';
import styles from './Confirmation.module.css';
import { SuccessIcon } from '../../../components/icons/successIcon';
import AssociateRealtime from '../../../context/AssociateRealtimeProvider';
import { formatDistanceStrict } from 'date-fns';
import { useSelector } from 'react-redux';
import { getLocale } from '../../../helpers/dates';

const Confirmation = ({ history }) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const { connection } = useContext(AssociateRealtime);
  const [loading, setLoading] = useState(true);
  const [reservation, setReservation] = useState(null);
  const reservationId = getQueryString('reservationId');
  const [copied, setCopied] = useState(false);
  const [reservationPaid, setReservationPaid] = useState(null);
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);

  const getRervationLink = async () => {
    try {
      const result = await getReservation(reservationId, welletContext);
      setReservation(result);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleCopyLink = () => {
    const link = reservation?.detail?.paymentInformation?.paymentLink;
    if (link) {
      navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const renderQR = () => {
    return (
      <>
        <div className='mt-5 pt-3 px-3'>
          <div className='bold font-large text-center'>{t('linkCreated')}</div>
          <div className='d-flex justify-content-center mt-3'>
            <Qr
              qrUrl={encodeURIComponent(reservation.detail.paymentInformation.paymentLink)}
              welletContext={welletContext}
              logo={reservation.showLogoImageUrl}
              logoBorder='ROUNDED'
            />
          </div>
          <div className='row mt-4'>
            <div className='col-auto my-auto pr-0'>
              <div className={styles.itemExplanation}>1</div>
            </div>
            <div className='col'>{t('qrInstructions.step1')}</div>
          </div>
          <div className='row mt-3'>
            <div className='col-auto my-auto pr-0'>
              <div className={styles.itemExplanation}>2</div>
            </div>
            <div className='col my-auto'>
              {t('qrInstructions.step2', {
                time: formatDistanceStrict(
                  new Date(reservation.detail.paymentInformation.expirePayment),
                  new Date(reservation.createdDate),
                  { locale },
                ),
              })}
            </div>
          </div>
          <div className='mt-5 text-center'>{t('waitingCustomerPyment')}</div>
        </div>
        {reservationPaid && renderSuccess()}
      </>
    );
  };

  const renderSuccess = () => {
    return (
      <div className={styles.animationContainer}>
        <div className={styles.circle}></div>
        <div className={styles.successContainer}>
          <div className={`text-center py-5 mt-3 ${styles.checkmark}`}>
            <SuccessIcon size={'110px'} color={'#FFF'} />
          </div>
          <div className='container mt-4'>
            <div className='font-extra-large fw-bold'>{t('paymentCompleted')}</div>
            <div className={`mt-4 pb-3 ${styles.border}`}>
              <div>
                <div className='font-tiny'>{t('businessUnit')}</div>
                <div
                  className={`d-flex justify-content-between align-items-center ${styles.containerBorder}`}
                >
                  <div className='font-medium bold'>{reservationPaid.show.name}</div>
                </div>
              </div>
            </div>
            <div className='mt-3 font-tiny text-uppercase'>{reservationPaid.currency}</div>
            <div className='font-medium bold'>
              <Money value={reservationPaid.totalAmount} />
            </div>
            <div className='mt-4 font-tiny text-uppercase'>{t('internalReference')}</div>
            <div className=' font-tiny'>{reservationPaid.externalReferenceCode}</div>
            <div className='d-flex justify-content-end pt-4 pb-5'>
              <div
                className={`font-normal bold ${styles.button} ${styles.buttonBorderValid}`}
                onClick={() =>
                  history.push({
                    pathname: `/link-home`,
                  })
                }
              >
                {t('checkShow.following')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const onPaidReservation = (item) => {
    if (item.reservationId === parseInt(reservationId)) {
      setReservationPaid(item);
    }
  };

  useEffect(() => {
    if (reservation == null) getRervationLink();
  }, []);

  useEffect(() => {
    if (connection) {
      connection.on('PaidReservation', onPaidReservation);
    }

    return () => {
      if (connection) {
        connection.off('PaidReservation', onPaidReservation);
      }
    };
  }, [connection]);

  return (
    <>
      <Header
        showClose={reservation?.notificationMethod === 'QR'}
        onClose={() => history.push('/')}
        showBack={reservation?.notificationMethod !== 'QR'}
      />
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          {reservation && (
            <ContentApp>
              {reservation.notificationMethod === 'QR' ? (
                renderQR()
              ) : (
                <>
                  <div className={`d-flex align-items-center justify-content-center pt-5 `}>
                    <SuccessCheck color='var(--color-primary)' size={200} />
                  </div>
                  <div className='mt-5 pt-3 px-3' style={{ textAlign: 'center' }}>
                    <div className='bold font-large'>
                      {reservation.notificationMethod === 'WHATSAPP' ||
                      reservation.notificationMethod === 'EMAIL'
                        ? t('linkSent')
                        : t('linkCreated')}
                    </div>
                    <div className='text-secondary semi-bold font-normal mt-3'>
                      {reservation.notificationMethod !== 'WHATSAPP' &&
                      reservation.notificationMethod !== 'EMAIL' &&
                      reservation.notificationMethod !== 'QR'
                        ? t('linkMade', {
                            name: reservation.customerName,
                          })
                        : t('weSend', {
                            name: reservation.customerName,
                          })}

                      <Money symbol={reservation.currency} value={reservation.depositAmount} />
                    </div>
                  </div>
                  <div
                    className='position-relative font-tiny text-truncate text-center mt-4 pr-5'
                    style={{ height: '50px' }}
                  >
                    <a href={reservation.detail.paymentInformation.paymentLink} target='_blank'>
                      {reservation.detail.paymentInformation.paymentLink}
                    </a>
                    <span
                      onClick={handleCopyLink}
                      style={{ position: 'absolute', right: '1.5rem', top: '-1px' }}
                    >
                      <CopyIcon size={19} fillColor='#00A3FF' />
                    </span>
                    {copied && (
                      <Toast
                        bottom={'100px'}
                        top={false}
                        type={'success'}
                        message={t('linkCopied')}
                        delay={20}
                      />
                    )}
                  </div>
                  <FixedButton>
                    <Button
                      text={t('returnHome')}
                      size='large'
                      className={`mt-2 `}
                      onClick={() => history.push('/link-home')}
                      icon={true}
                      typeIcon='arrow'
                      iconColor='#000'
                    />
                  </FixedButton>
                </>
              )}
            </ContentApp>
          )}
        </>
      )}
    </>
  );
};

export default Confirmation;
